import * as yup from 'yup';

import { CountriesList } from '@/shared/constants/countries-list';
import { TDtoWrapper } from '@/shared/lib/forms/form-wrapper.types';
import { QuestionType } from '@/shared/lib/sj-orm/models/form/question.dto';

import {
  CentralizedWalletDetailsType,
  CentralizedWalletGeneralType,
} from '../../sj-orm/models/assets/categories';
import { CurrenciesType } from '../../sj-orm/models/assets/enums';

import { assetsDocumentsBuilder, AssetsDocumentsPartType } from './builders/documents';
import { assetsOwnershipBuilder, AssetsOwnershipPartType } from './builders/ownership';
import { assetsProfitabilityBuilder, AssetsProfitabilityPartType } from './builders/profitability';
import { assetsStatisticsBuilder, AssetsStatisticsPartType } from './builders/statistics';
import { baseAssetFields } from './fields';

export const CurrenciesList = [
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.BTC',
    key: CurrenciesType.BTC,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.ETH',
    key: CurrenciesType.ETH,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.USDT',
    key: CurrenciesType.USDT,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.USDC',
    key: CurrenciesType.USDC,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.1INCH',
    key: CurrenciesType.OneINCH,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.AAVE',
    key: CurrenciesType.AAVE,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.ELF',
    key: CurrenciesType.ELF,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.AKT',
    key: CurrenciesType.AKT,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.ALGO',
    key: CurrenciesType.ALGO,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.ar',
    key: CurrenciesType.ar,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.AVAX',
    key: CurrenciesType.AVAX,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.AXS',
    key: CurrenciesType.AXS,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.BTCB',
    key: CurrenciesType.BTCB,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.BCH',
    key: CurrenciesType.BCH,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.BSV',
    key: CurrenciesType.BSV,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.BNB',
    key: CurrenciesType.BNB,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.BUSD',
    key: CurrenciesType.BUSD,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.ADA',
    key: CurrenciesType.ADA,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.CSPR',
    key: CurrenciesType.CSPR,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.LINK',
    key: CurrenciesType.LINK,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.CHZ',
    key: CurrenciesType.CHZ,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.COMP',
    key: CurrenciesType.COMP,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.CFX',
    key: CurrenciesType.CFX,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.ATOM',
    key: CurrenciesType.ATOM,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.CRO',
    key: CurrenciesType.CRO,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.CRV',
    key: CurrenciesType.CRV,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.DASH',
    key: CurrenciesType.DASH,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.MANA',
    key: CurrenciesType.MANA,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.DOGE',
    key: CurrenciesType.DOGE,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.DYDX',
    key: CurrenciesType.DYDX,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.XEC',
    key: CurrenciesType.XEC,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.EOS',
    key: CurrenciesType.EOS,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.ETC',
    key: CurrenciesType.ETC,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.FTM',
    key: CurrenciesType.FTM,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.FET',
    key: CurrenciesType.FET,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.FIL',
    key: CurrenciesType.FIL,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.FLOW',
    key: CurrenciesType.FLOW,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.FXS',
    key: CurrenciesType.FXS,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.FTT',
    key: CurrenciesType.FTT,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.GALA',
    key: CurrenciesType.GALA,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.GAS',
    key: CurrenciesType.GAS,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.gt',
    key: CurrenciesType.gt,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.GNO',
    key: CurrenciesType.GNO,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.HBAR',
    key: CurrenciesType.HBAR,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.HNT',
    key: CurrenciesType.HNT,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.HOT',
    key: CurrenciesType.HOT,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.ht',
    key: CurrenciesType.ht,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.ILV',
    key: CurrenciesType.ILV,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.INJ',
    key: CurrenciesType.INJ,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.ICP',
    key: CurrenciesType.ICP,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.IOTA',
    key: CurrenciesType.IOTA,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.IOTX',
    key: CurrenciesType.IOTX,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.KAVA',
    key: CurrenciesType.KAVA,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.KLAY',
    key: CurrenciesType.KLAY,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.KCS',
    key: CurrenciesType.KCS,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.LDO',
    key: CurrenciesType.LDO,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.LTC',
    key: CurrenciesType.LTC,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.MKR',
    key: CurrenciesType.MKR,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.MINA',
    key: CurrenciesType.MINA,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.XMR',
    key: CurrenciesType.XMR,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.DAI',
    key: CurrenciesType.DAI,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.EGLD',
    key: CurrenciesType.EGLD,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.NEAR',
    key: CurrenciesType.NEAR,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.NEO',
    key: CurrenciesType.NEO,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.NEXO',
    key: CurrenciesType.NEXO,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.ROSE',
    key: CurrenciesType.ROSE,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.OKB',
    key: CurrenciesType.OKB,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.CAKE',
    key: CurrenciesType.CAKE,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.USDP',
    key: CurrenciesType.USDP,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.DOT',
    key: CurrenciesType.DOT,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.MATIC',
    key: CurrenciesType.MATIC,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.QNT',
    key: CurrenciesType.QNT,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.RNDR',
    key: CurrenciesType.RNDR,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.RPL',
    key: CurrenciesType.RPL,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.SHIB',
    key: CurrenciesType.SHIB,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.sc',
    key: CurrenciesType.sc,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.AGIX',
    key: CurrenciesType.AGIX,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.SOL',
    key: CurrenciesType.SOL,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.STX',
    key: CurrenciesType.STX,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.XLM',
    key: CurrenciesType.XLM,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.STORJ',
    key: CurrenciesType.STORJ,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.SNX',
    key: CurrenciesType.SNX,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.XTZ',
    key: CurrenciesType.XTZ,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.GRT',
    key: CurrenciesType.GRT,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.SAND',
    key: CurrenciesType.SAND,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.THETA',
    key: CurrenciesType.THETA,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.RUNE',
    key: CurrenciesType.RUNE,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.TRX',
    key: CurrenciesType.TRX,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.TUSD',
    key: CurrenciesType.TUSD,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.TWT',
    key: CurrenciesType.TWT,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.UNI',
    key: CurrenciesType.UNI,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.LEO',
    key: CurrenciesType.LEO,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.VET',
    key: CurrenciesType.VET,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.WEMIX',
    key: CurrenciesType.WEMIX,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.WOO',
    key: CurrenciesType.WOO,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.WBTC',
    key: CurrenciesType.WBTC,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.XDC',
    key: CurrenciesType.XDC,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.XRP',
    key: CurrenciesType.XRP,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.ZEC',
    key: CurrenciesType.ZEC,
  },
  {
    label: 'forms_assets:centralizedWallet.enums.assetsInWallet.ZIL',
    key: CurrenciesType.ZIL,
  },
];

export type CentralizedWallet = CentralizedWalletGeneralType &
  CentralizedWalletDetailsType &
  Omit<AssetsOwnershipPartType, 'createdAt' | 'updatedAt'> &
  Omit<AssetsProfitabilityPartType, 'createdAt' | 'updatedAt'> &
  AssetsStatisticsPartType &
  Omit<AssetsDocumentsPartType, 'createdAt' | 'updatedAt'>;

type CentralizedWalletHelpGeneralType = {
  nickname: QuestionType.TEXT;
  country: QuestionType.SELECT_FROM_LIST;
  purchaseValue: QuestionType.CURRENCY_CALCULATOR;
  assetsInWallet: QuestionType.SELECT_FROM_LIST;
  holder: QuestionType.TEXT;
};

type CentralizedWalletHelpDetailsType = {
  accountNumber?: QuestionType.TEXT;
  loginStorageLocation?: QuestionType.TEXT;
  kyc?: QuestionType.CHECKBOX;
  attachments?: QuestionType.FILE_UPLOAD;
};

type CentralizedWalletFormGeneralType = TDtoWrapper<
  CentralizedWalletGeneralType,
  CentralizedWalletHelpGeneralType
>;

type CentralizedWalletFormDetailsType = TDtoWrapper<
  CentralizedWalletDetailsType,
  CentralizedWalletHelpDetailsType
>;

const CentralizedWalletFormGeneral: CentralizedWalletFormGeneralType = {
  nickname: {
    type: QuestionType.TEXT,
    label: 'forms_assets:common.inputs.nickname.label',
    value: '',
    required: true,
    yupScheme: yup.string().required('forms_assets:common.inputs.nickname.errors.required'),
    colSpan: 2,
  },
  country: {
    type: QuestionType.SELECT_FROM_LIST,
    label: 'forms_assets:common.inputs.country.label',
    tooltip: 'forms_assets:common.inputs.country.tooltip',
    value: '',
    required: true,
    items: CountriesList,
    withSearch: true,
  },
  purchaseValue: {
    type: QuestionType.CURRENCY_CALCULATOR,
    label: 'forms_assets:centralizedWallet.inputs.purchaseValue.label',
    tooltip: 'forms_assets:centralizedWallet.inputs.purchaseValue.tooltip',
    equivalentValueTooltip: 'forms_assets:common.inputs.equivalentValue.tooltip',
    value: 0,
    required: true,
  },
  assetsInWallet: {
    type: QuestionType.SELECT_FROM_LIST,
    label: 'forms_assets:centralizedWallet.inputs.assetsInWallet.label',
    value: [CurrenciesType.BTC],
    items: CurrenciesList,
    mode: 'multiple',
  },
  holder: {
    type: QuestionType.TEXT,
    label: 'forms_assets:centralizedWallet.inputs.holder.label',
    tooltip: 'forms_assets:centralizedWallet.inputs.holder.tooltip',
    yupScheme: yup
      .string()
      .required('forms_assets:centralizedWallet.inputs.holder.errors.required'),
  },
};

const CentralizedWalletFormDetails: CentralizedWalletFormDetailsType = {
  accountNumber: {
    type: QuestionType.TEXT,
    label: 'forms_assets:centralizedWallet.inputs.accountNumber.label',
    order: 1,
  },
  loginStorageLocation: {
    type: QuestionType.TEXT,
    label: 'forms_assets:centralizedWallet.inputs.loginStorageLocation.label',
    order: 2,
  },
  kyc: {
    type: QuestionType.CHECKBOX,
    label: 'forms_assets:centralizedWallet.inputs.kyc.label',
    tooltip: 'forms_assets:centralizedWallet.inputs.kyc.tooltip',
    order: 3,
  },
  attachments: baseAssetFields.attachments,
  // insuranceAgreement: baseAassetFields.insuranceAgreement,
};

const CentralizedWalletForm = [
  CentralizedWalletFormGeneral,
  CentralizedWalletFormDetails,
  assetsOwnershipBuilder().form,
  assetsProfitabilityBuilder([]),
  assetsStatisticsBuilder([
    'taxAgent',
    'taxAgentOther',
    'taxAgentWithBroker',
    'taxAgentWithBrokerOther',
    'publicFundTaxAgent',
    'publicTaxAgentOther',
    'legalTaxAgent',
    'legalTaxAgentOther',
    'holderTaxAgent',
    'holderTaxAgentOther',
    'specificsOfTaxation',
    'profitabilityFact',
    'profitabilityPlan',
  ]).form,
  assetsDocumentsBuilder(),
];

export { CentralizedWalletForm };
